import Swiper, { Navigation, Pagination, Mousewheel, FreeMode, Scrollbar, Controller } from 'swiper'

const initTimeline = () => {

  const focusSlider = document.querySelector('.focus-slider')

  if (focusSlider) {
    // Focus Years Slider
    const slider = new Swiper('.focus-slider', {
      modules: [Controller],
      direction: 'vertical',
      centeredSlides: true,
      slidesPerView: 3
    })
  
    // Focus Sections Slider
    const focusSectionsSlider = new Swiper('.focus-sections', {
      modules: [Navigation, Pagination, Mousewheel, FreeMode, Scrollbar, Controller],
      direction: 'vertical',
      allowTouchMove: false,
      mousewheel: {
        sensitivity: 1
      },
      slidesPerView: 1,
      freeMode: {
        enabled: true,
        sticky: false,
        momentumBounce: false,
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      breakpoints: {
        1170: {
          freeMode: {
            enabled: true,
            sticky: true,
            momentumBounce: false,
          },
        }
      }
    })
  
    // Focus News Slider
    const newsSlider = new Swiper('.focus-news-slider', {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
  
    slider.controller.control = focusSectionsSlider;
    focusSectionsSlider.controller.control = slider;
  
    // Click Actions
    const slides = document.querySelectorAll('.focus-slider a')
  
    if (slides.length) {
      slides.forEach((slide, index) => {
        slide.addEventListener('click', (e) => {
          e.preventDefault();
          slider.slideTo(index)
        })
      })
    }
  
    // Years Slider Actions
    const hideSlider = () => {
      const hideSlider = document.querySelector('.section-swiper-wrapper')
      const firstSlide = document.querySelector('.swiper-slide.first-slide')
    
      if (hideSlider && firstSlide) {
        if (firstSlide.classList.contains('swiper-slide-active')) {
          hideSlider.classList.add('section-swiper-wrapper-hide')
        } else {
          hideSlider.classList.remove('section-swiper-wrapper-hide')
        }
      }
    }
  
    hideSlider()
  
    focusSectionsSlider.on('scroll', function () {
      hideSlider()
    })
  
    // Scroll Actions
    window.addEventListener('scroll', () => {
      const swiperOverlay = document.querySelector('.swiper-overlay')
  
      if (swiperOverlay) {
        const box = document.querySelector('.focus-sections');
        const rect = box.getBoundingClientRect();
        const isInViewport = rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
      
        isInViewport ? swiperOverlay.classList.add('active') : swiperOverlay.classList.remove('active')
      }
    })
  
    // Destroy Slider
    const mqw = window.matchMedia('(max-width: 1170px)')
    const mqh = window.matchMedia('(max-height: 930px)')
    
    if (mqw.matches || mqh.matches) {
      focusSectionsSlider.destroy()
    }
  }
}

initTimeline();
